<template lang="pug">
  span.block(
    :class="[styleClass, sizeClass]"
    :style="{strokeLinecap: 'round', strokeLinejoin: 'round'}"
    v-html="require(`!!svg-inline-loader?removeTags&removingTags=style&removingTagAttrs[]=class&removingTagAttrs[]=style&removingTagAttrs[]=version&removingTagAttrs[]=xmlns:xlink&removingTagAttrs[]=xml:space&removingTagAttrs[]=xmlns:serif!../../icons/${name}.svg`)")
</template>

<script>
export default {
  name: 'SwIcon',
  props: {
    name: {
      type: String,
      default: '',
    },
    unstyled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'w-6 h-6',
    },
  },
  computed: {
    sizeClass () {
      return this.size;
    },
    styleClass () {
      return this.unstyled ? '' : 'fill-none stroke-current stroke-2';
    },
  },
};
</script>
